import isEqual from 'lodash/isEqual';
import pick from 'lodash/pick';
import PropTypes from 'prop-types';
import React, { Component } from 'react';
import { createCustomPropType, isNumeric, isUuid } from '../../../../js/app/react/validators';
import AdvForm from '../../../CommonComponents/AdvForm';
import { simpleSelectDefaultValue } from '../../../Profile/Accounts_react/AccountsUtils';
import Footer from '../../Footer/FooterContainer';
import Loading from '../../Loading/LoadingView';
import PlanImpact from '../../PlanImpact/PlanImpactContainer';
import ValidationErrors from '../../ValidationErrors/ValidationErrorsContainer';
import { Select } from '../../../CommonComponents/OPL/Select/Select/Select';

const dafSelectDefaultValue = (options, selectedObj) => {
  if (!selectedObj) return null;
  return (
    options.find(opt => opt.value === selectedObj.Year && opt.type === selectedObj.Type) || null
  );
};

const isNumericOrNull = value => value === null || isNumeric(value);

class DonationYearView extends Component {
  componentDidMount() {
    const {
      fetchData,
      clientId,
      fpId,
      goalId,
      fetchInitialPlanImpact,
      whatIf,
      whatIfTemplate,
    } = this.props;

    fetchData(clientId, fpId, goalId, whatIfTemplate.WhatIfType);
    fetchInitialPlanImpact(clientId, fpId, goalId, whatIf, whatIfTemplate);
  }

  componentDidUpdate(prevProps) {
    const { clientId, fpId, goalId, whatIf, fetchPlanImpact, whatIfTemplate } = this.props;
    const impactTriggerProps = ['whatIf'];

    if (!isEqual(pick(this.props, impactTriggerProps), pick(prevProps, impactTriggerProps))) {
      fetchPlanImpact(clientId, fpId, goalId, whatIf, whatIfTemplate);
    }
  }

  render() {
    const {
      clientId,
      fpId,
      goalId,
      loading,
      title,
      groupTitle,
      whatIf,
      whatIfTemplate,
      applyWhatIf,
      areOptionsLoaded,
      planImpactItems,
      onYearChange,
      yearsOptions,
      dafStartYearOptions,
      dafEndYearOptions,
      donationStartYear,
      donationEndYear,
      dafDonationStartYear,
      dafDonationEndYear,
      dafGrantStartYear,
      dafGrantEndYear,
      storeData,
      isRecurring,
    } = this.props;
    return (
      <div className="what-ifs-layout">
        {loading && <Loading />}
        <div className="what-ifs-section what-ifs-layout-header">
          <h3>What-If...</h3>
        </div>
        <div className="what-ifs-layout-content">
          <h4 className="what-if-group-title">{groupTitle}</h4>
          <AdvForm>
            <ValidationErrors clientId={clientId} />
            <ul className={`what-ifs-form-fields what-ifs-box${areOptionsLoaded ? ' loaded' : ''}`}>
              <li className="what-ifs-form-field">
                <h5 className="what-if-title">{title}</h5>
              </li>
              {yearsOptions.length > 0 && (
                <>
                  <li className="what-ifs-form-field">
                    <Select
                      label={isRecurring ? 'Start Year' : 'Donation Year'}
                      isPortal
                      value={simpleSelectDefaultValue(yearsOptions, donationStartYear)}
                      onChange={selectedOption => {
                        onYearChange(
                          clientId,
                          goalId,
                          whatIfTemplate.WhatIfType,
                          'DonationStartYear',
                          selectedOption,
                        );
                      }}
                      options={yearsOptions}
                    />
                  </li>
                  {isRecurring && (
                    <li className="what-ifs-form-field">
                      <Select
                        label="End Year"
                        isPortal
                        value={simpleSelectDefaultValue(yearsOptions, donationEndYear)}
                        onChange={selectedOption => {
                          onYearChange(
                            clientId,
                            goalId,
                            whatIfTemplate.WhatIfType,
                            'DonationEndYear',
                            selectedOption,
                          );
                        }}
                        options={yearsOptions}
                      />
                    </li>
                  )}
                  <li className="what-ifs-form-field what-ifs-form-field-no-box">
                    <label htmlFor="IsRecurring" className="what-ifs-age-label what-ifs-checkbox">
                      <input
                        type="checkbox"
                        id="IsRecurring"
                        className="what-ifs-checkbox-toggle"
                        checked={isRecurring}
                        onChange={event => {
                          const checked = event.target.checked;
                          storeData(goalId, whatIfTemplate.WhatIfType)(
                            {
                              WhatIf: {
                                IsRecurring: checked,
                                DonationEndYear: checked ? donationEndYear : null,
                              },
                            },
                            clientId,
                          );
                        }}
                      />
                      <i className="what-ifs-checkbox-mark" />
                      <span className="what-ifs-checkbox-label-text">Recurring</span>
                    </label>
                  </li>
                </>
              )}

              {dafStartYearOptions.length > 0 && (
                <>
                  <li className="what-ifs-form-field">
                    <Select
                      label="DAF Donation Start Year"
                      isPortal
                      value={dafSelectDefaultValue(dafStartYearOptions, dafDonationStartYear)}
                      onChange={selectedOption =>
                        onYearChange(
                          clientId,
                          goalId,
                          whatIfTemplate.WhatIfType,
                          'DafDonationStartYear',
                          selectedOption,
                        )
                      }
                      options={dafStartYearOptions}
                      placeholder="Select Donation Start Year"
                    />
                  </li>
                  <li className="what-ifs-form-field">
                    <Select
                      label="DAF Donation End Year"
                      isPortal
                      value={dafSelectDefaultValue(dafEndYearOptions, dafDonationEndYear)}
                      onChange={selectedOption =>
                        onYearChange(
                          clientId,
                          goalId,
                          whatIfTemplate.WhatIfType,
                          'DafDonationEndYear',
                          selectedOption,
                        )
                      }
                      options={dafEndYearOptions}
                      placeholder="Select Donation End Year"
                    />
                  </li>
                  <li className="what-ifs-form-field">
                    <Select
                      label="Grant Start Year(Optional)"
                      isPortal
                      value={dafSelectDefaultValue(dafStartYearOptions, dafGrantStartYear)}
                      onChange={selectedOption =>
                        onYearChange(
                          clientId,
                          goalId,
                          whatIfTemplate.WhatIfType,
                          'DafGrantStartYear',
                          selectedOption,
                        )
                      }
                      options={dafStartYearOptions}
                      placeholder="Select Grant Start Year"
                    />
                  </li>
                  <li className="what-ifs-form-field">
                    <Select
                      label="Grant End Year(Optional)"
                      isPortal
                      value={dafSelectDefaultValue(dafEndYearOptions, dafGrantEndYear)}
                      onChange={selectedOption =>
                        onYearChange(
                          clientId,
                          goalId,
                          whatIfTemplate.WhatIfType,
                          'DafGrantEndYear',
                          selectedOption,
                        )
                      }
                      options={dafEndYearOptions}
                      placeholder="Select Grant End Year"
                    />
                  </li>
                </>
              )}
            </ul>
          </AdvForm>
        </div>
        <PlanImpact clientId={clientId} planImpactItems={planImpactItems} />
        <Footer
          clientId={clientId}
          applyToPlanCallback={applyWhatIf(clientId, fpId, goalId, whatIf, whatIfTemplate)}
        />
      </div>
    );
  }
}

DonationYearView.defaultProps = {
  title: 'Untitled Donation What-If',
  groupTitle: 'Charitable Giving',
};

DonationYearView.propTypes = {
  planImpactItems: PropTypes.arrayOf(
    PropTypes.shape({
      label: PropTypes.string.isRequired,
      current: PropTypes.string.isRequired,
      proposed: PropTypes.string.isRequired,
    }),
  ).isRequired,
  goalId: createCustomPropType(isUuid).isRequired,
  fpId: createCustomPropType(isUuid).isRequired,
  clientId: createCustomPropType(isNumeric).isRequired,
  title: PropTypes.string,
  groupTitle: PropTypes.string,
  areOptionsLoaded: PropTypes.bool.isRequired,
  whatIf: PropTypes.shape({}).isRequired,
  whatIfTemplate: PropTypes.shape({}).isRequired,
  fetchData: PropTypes.func.isRequired,
  loading: PropTypes.bool.isRequired,
  fetchInitialPlanImpact: PropTypes.func.isRequired,
  fetchPlanImpact: PropTypes.func.isRequired,
  applyWhatIf: PropTypes.func.isRequired,
  onYearChange: PropTypes.func.isRequired,
  yearsOptions: PropTypes.arrayOf(PropTypes.shape({})).isRequired,
  dafStartYearOptions: PropTypes.arrayOf(PropTypes.shape({})).isRequired,
  donationStartYear: createCustomPropType(isNumericOrNull),
  donationEndYear: createCustomPropType(isNumericOrNull),
  dafDonationStartYear: PropTypes.shape({
    Year: PropTypes.oneOfType([PropTypes.number, PropTypes.null]),
    Type: PropTypes.number,
  }),
  storeData: PropTypes.func.isRequired,
};

export default DonationYearView;
